import { Button, Col, Row, Tooltip } from "antd";
import React, { useState } from "react";
import palm from "../../assets/icons/palm-icon.svg";
import palmGray from "../../assets/icons/palm-gray-icon.svg";
import Perso from "../../assets/icons/Perso.svg";
import location from "../../assets/icons/location-border.svg";
import terrain from "../../assets/icons/terrain-icon.svg";
import share from "../../assets/icons/share.svg";
import money from "../../assets/icons/money-icon.svg";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import ModalComponent from "../../biblio/Modal/ModalComponent";
import SharePalm from "../share-cases/SharePalm";
import { useNavigate } from "react-router-dom";

interface PalmProps {
  palms: any;
  isPalmModalOpen: any;
  setIsPalmModalOpen: any;
}

const CardPalm = ({
  palms,
  isPalmModalOpen,
  setIsPalmModalOpen,
}: PalmProps) => {
  const navigate = useNavigate();
  const [isShareModalOpen, setIsShareModalVisible] = useState<boolean>(false);

  const showModal = () => {
    setIsShareModalVisible(true);
    setIsPalmModalOpen(false);
  };

  return (
    <>
      <ModalComponent
        title=""
        open={isPalmModalOpen}
        onClose={() => setIsPalmModalOpen(false)}
        closeOnOutsideClick={true}
        showCloseIcon={false}
        width={550}
        modalStyle={{ top: -200 }}
        centered={true}
      >
        <div className="takaful--card-palm-container">
          <Row
            gutter={8}
            dir="rtl"
            align={"middle"}
            className="takaful--card-palm-header"
          >
            <Col>
              <img width={15} src={palm} alt="palm" />
            </Col>
            <Col>
              <span>وقف النخيل</span>
            </Col>
          </Row>
          <img src={palms.image_banner_ids} width={"100%"} alt="" />

          {/* Data part */}
          <Row
            gutter={[4, 16]}
            dir="rtl"
            align={"middle"}
            className="takaful--card-palm-data-container"
          >
            <Col
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={{ span: 19, order: 1 }}
              xs={{ span: 19, order: 1 }}
              className="takaful--card-palm-data"
            >
              <img alt="" src={Perso} width={40} />
              <span>{palms?.participant_number} مساهم</span>
            </Col>
            <Col
              xxl={{ span: 9, order: 2 }}
              xl={{ span: 9, order: 2 }}
              lg={{ span: 9, order: 2 }}
              md={{ span: 9, order: 2 }}
              sm={{ span: 24, order: 4 }}
              xs={{ span: 24, order: 4 }}
              className="takaful--card-palm-data"
            >
              <img alt="" src={location} width={40} />
              <span>{palms?.address}، المدينة المنورة</span>
            </Col>
            <Col
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={{ span: 24, order: 3 }}
              xs={{ span: 24, order: 3 }}
              className="takaful--card-palm-data"
            >
              <img alt="" src={terrain} width={40} />
              <span>{palms?.farm_number} مزرعة</span>
            </Col>
            <Col
              xxl={{ span: 3, order: 4 }}
              xl={{ span: 3, order: 4 }}
              lg={{ span: 3, order: 4 }}
              md={{ span: 3, order: 4 }}
              sm={{ span: 5, order: 2 }}
              xs={{ span: 5, order: 2 }}
            >
              <Tooltip
                overlayClassName="takaful--share-tooltip"
                placement="bottom"
                title={"شارك وقف النخيل عبر التواصل الإجتماعي"}
                getPopupContainer={(triggerNode) =>
                  triggerNode.closest(".takaful--card-palm-container") ||
                  document.body
                }
              >
                <Button
                  className="takaful--share-btn"
                  onClick={() => showModal()}
                  style={{ float: "left" }}
                >
                  <img src={share} width={20} alt="" />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          {/* Description part */}
          <Row
            dir="rtl"
            gutter={4}
            justify={"center"}
            className="takaful--palm-details-container takaful--card-palm-details-container"
            style={{ marginTop: "2rem" }}
          >
            <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
              <Row align={"middle"} className="takaful--palm-details-row">
                <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={4}>
                  <img alt="" src={palmGray} width={20} />
                </Col>
                <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9}>
                  <span className="takaful--palm-details-title">
                    عدد النخيل
                  </span>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9}>
                  <p className="takaful--palm-details-value">
                    {palms?.palm_number}
                  </p>
                </Col>
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={2}
                  xs={2}
                  className="takaful--palm-details-unit"
                >
                  <h6>نخلة</h6>
                </Col>
              </Row>
            </Col>
            <Col
              xxl={1}
              xl={1}
              lg={1}
              md={1}
              sm={0}
              xs={0}
              className="takaful--palm-details-divider-container"
            >
              <div className="takaful--palm-details-divider-color"></div>
            </Col>
            <Col xxl={0} xl={0} lg={0} md={0} sm={24} xs={24}>
              <hr />
            </Col>
            <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
              <Row align={"middle"} className="takaful--palm-details-row-1">
                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                  <img alt="" src={money} width={30} />
                </Col>
                <Col xxl={10} xl={10} lg={10} md={10} sm={9} xs={9}>
                  <span className="takaful--palm-details-title takaful--palm-details-title-green ">
                    قيمة السهم
                  </span>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9}>
                  <p className="takaful--palm-details-value ">
                    {palms?.share_amount}
                  </p>
                </Col>
                <Col
                  xxl={2}
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="takaful--palm-details-unit"
                >
                  <h6 aria-hidden="true" className="icon-saudi_riyal"></h6>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Button part */}
          <div style={{ paddingTop: "2rem" }}>
            <PrimaryButton
              title="ساهم الآن"
              className="takaful--palm-button-primary"
              onClick={() => navigate(`/palm-endowment/${palms?.access_token}`)}
            />
          </div>
        </div>
      </ModalComponent>

      <SharePalm
        isShareModalOpen={isShareModalOpen}
        setIsShareModalVisible={(e: boolean) => setIsShareModalVisible(e)}
        setIsPalmModalOpen={() => setIsPalmModalOpen(true)}
        url={`${window.location.origin}/palm-endowment/${palms?.access_token}`}
        title="وقف النخيل"
      />
    </>
  );
};

export default CardPalm;
